import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import api from "../../lib/api";
import { School, Users, GraduationCap, BookOpen } from "lucide-react";

export default function SchoolDashboard() {
  const { t } = useTranslation();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/school/overview").then((r) => setD(r.data)); }, []);
  if (!d) return <AppShell><div>{t("common.loading")}</div></AppShell>;

  return (
    <AppShell>
      <h1 className="font-adult font-bold text-3xl text-slate-900">{d.school?.name || t("school.overview")}</h1>
      <p className="text-slate-600">{t("school.manageBody")}</p>

      <div className="grid md:grid-cols-4 gap-4 mt-6">
        <Stat icon={GraduationCap} label={t("school.teachers")} value={d.teachers.length} color="bg-blue-500" />
        <Stat icon={BookOpen} label={t("school.classes")} value={d.classes.length} color="bg-green-500" />
        <Stat icon={Users} label={t("school.students")} value={d.students_count} color="bg-yellow-500" />
        <Stat icon={School} label={t("school.seats")} value={d.school?.seats_licensed ?? 0} color="bg-slate-800" />
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-6">
        <div className="hb-card p-5">
          <div className="font-adult font-bold text-slate-900">{t("school.teachers")}</div>
          <ul className="mt-3 space-y-2">
            {d.teachers.map((tt) => <li key={tt.id} className="p-2 rounded-lg border border-slate-200 flex justify-between text-sm">
              <span className="font-semibold">{tt.full_name}</span><span className="text-slate-500">{tt.email}</span>
            </li>)}
            {d.teachers.length === 0 && <li className="text-sm text-slate-500">{t("school.noTeachers")}</li>}
          </ul>
        </div>
        <div className="hb-card p-5">
          <div className="font-adult font-bold text-slate-900">{t("school.classes")}</div>
          <ul className="mt-3 space-y-2">
            {d.classes.map((c) => <li key={c.id} className="p-2 rounded-lg border border-slate-200 flex justify-between text-sm">
              <span className="font-semibold">{c.name}</span><span className="text-slate-500 font-mono">{c.class_code}</span>
            </li>)}
            {d.classes.length === 0 && <li className="text-sm text-slate-500">{t("school.noClasses")}</li>}
          </ul>
        </div>
      </div>
    </AppShell>
  );
}

function Stat({ icon: Icon, label, value, color }) {
  return (
    <div className="hb-card p-4">
      <div className={`w-9 h-9 rounded-lg ${color} text-white flex items-center justify-center`}><Icon className="w-4 h-4" /></div>
      <div className="mt-2 font-adult font-bold text-2xl text-slate-900">{value}</div>
      <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
    </div>
  );
}
